export const generatePayload = ({ eventType, ticketId }) => {
  return {
    ticketId,
    eventType
  }
}